module.exports = __webpack_public_path__ + "static/media/basic.39c22e59.png";